'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

// How far the user must scroll before the header leaves its tall "at top" state and
// collapses to compact mode. Kept comfortably above a few pixels so a tiny scroll
// nudge doesn't shrink the header.
const TOP_THRESHOLD = 120;

// How far the user must scroll (downward) before the header hides entirely. Kept well
// above TOP_THRESHOLD so the collapsed/compact header stays visible for a while first —
// otherwise it would hide almost immediately after shrinking and you'd never see it.
const HIDE_THRESHOLD = 360;
const useScrollDirection = () => {
  const $ = _c(8);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAtTop, setIsAtTop] = useState(true);
  let t0;
  if ($[0] !== lastScrollY) {
    t0 = () => {
      const updateScrollDirection = () => {
        const scrollY = window.scrollY;
        const direction = scrollY > lastScrollY ? "down" : "up";
        const isNowAtTop = scrollY < TOP_THRESHOLD;
        setIsAtTop(isNowAtTop);
        if (isNowAtTop) {
          setScrollDirection("up");
        } else {
          if (direction === "up") {
            setScrollDirection("up");
          } else {
            if (direction === "down" && scrollY > HIDE_THRESHOLD) {
              setScrollDirection("down");
            }
          }
        }
        setLastScrollY(scrollY);
      };
      window.addEventListener("scroll", updateScrollDirection);
      return () => window.removeEventListener("scroll", updateScrollDirection);
    };
    $[0] = lastScrollY;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== lastScrollY || $[3] !== scrollDirection) {
    t1 = [scrollDirection, lastScrollY];
    $[2] = lastScrollY;
    $[3] = scrollDirection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== isAtTop || $[6] !== scrollDirection) {
    t2 = {
      scrollDirection,
      isAtTop
    };
    $[5] = isAtTop;
    $[6] = scrollDirection;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default useScrollDirection;